import { render, staticRenderFns } from "./aitutormobile.vue?vue&type=template&id=690a20f1&"
import script from "./aitutormobile.vue?vue&type=script&lang=js&"
export * from "./aitutormobile.vue?vue&type=script&lang=js&"
import style0 from "./aitutormobile.vue?vue&type=style&index=0&id=690a20f1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports